const texts = {
  coachInformationTitle: 'Coach Information',
  promotionsTitle: 'Promotions',
};

export default texts;
